import { render, staticRenderFns } from "./CompanyDocumentsComponent.vue?vue&type=template&id=d7b70200&scoped=true&"
import script from "./CompanyDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./CompanyDocumentsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b70200",
  null
  
)

export default component.exports